import BaseRepository from '@/api/repositories/BaseRepository';
import { PDFDocumentTypes } from '@/api/models/PDFDocumentTypes';

export default class PDFRepository extends BaseRepository {
	get endpoint() {
		return 'api/pdf';
	}

	sentDocumentTo(email, uuids, message = undefined) {
		return this.post('mail/:email', { email }, { uuids, message });
	}

	/**
	 * @param processId
	 * @param type
	 * @param base64Content
	 * @param label
	 * @param uuid
	 * @returns {Promise<AxiosResponse<any>>}
	 */
	uploadFile(processId, type, base64Content, label = null, uuid = null) {
		const url = ['damagecases', processId, type, 'upload', label, uuid].filter(x => x).join('/');
		return this.post(url, null, base64Content);
	}

	getPDFFile(id, type = PDFDocumentTypes) {
		return this.get(`pdf/damagecases/${id}/${type}`, {});
	}

	getTempMaintenancePdf(data, type = PDFDocumentTypes) {
		return this.post(`maintenance/${type}/temp`, {}, data);
	}

	getMaintenancePdf(data, type = PDFDocumentTypes) {
		return this.post(`maintenance/${type}/save`, {}, data);
	}
}
